await import('/usr/src/app/src/.umi/umi.ts');
export default 1;